import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Instagram, Linkedin, Facebook, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/content";
import GoogleReviewsCard from "@/components/GoogleReviewsCard";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t-2 border-black bg-black text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="inline-block">
              <img src="/orina-logo-header.png" alt="Orina Enterprise" width="300" height="197" loading="lazy" decoding="async" className="block h-20 w-auto" />
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/70">
              India's No. 1 e-commerce & quick commerce onboarding agency — with proven expertise in Manpower & CRM solutions. All in 1 to make your business No. 1.
            </p>
            <div className="mt-6 flex gap-3">
              <a aria-label="LinkedIn" href="https://www.linkedin.com/company/orina-enterprise" target="_blank" rel="noreferrer" className="border-2 border-white p-2 hover:bg-[#FFD700] hover:text-black">
                <Linkedin size={16} />
              </a>
              <a aria-label="Instagram" href="https://www.instagram.com/orina_enterprise/" target="_blank" rel="noreferrer" className="border-2 border-white p-2 hover:bg-[#FFD700] hover:text-black">
                <Instagram size={16} />
              </a>
              <a aria-label="Facebook" href="https://www.facebook.com/p/Orina-Enterprise-61583540661975/" target="_blank" rel="noreferrer" className="border-2 border-white p-2 hover:bg-[#FFD700] hover:text-black">
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="display text-sm font-black uppercase tracking-widest text-[#FFD700]">Solutions</h4>
            <ul className="mt-4 space-y-0 text-sm text-white/80">
              <li><Link to="/services/" className="inline-block py-1.5 hover:text-[#FFD700]">Services</Link></li>
              <li><Link to="/marketplaces/" className="inline-block py-1.5 hover:text-[#FFD700]">Marketplaces</Link></li>
              <li><Link to="/premium-marketplaces/" className="inline-block py-1.5 hover:text-[#FFD700]">Premium MP</Link></li>
              <li><Link to="/quick-commerce/" className="inline-block py-1.5 hover:text-[#FFD700]">Quick Commerce</Link></li>
              <li><Link to="/web-app-development/" className="inline-block py-1.5 hover:text-[#FFD700]">Web & App Dev</Link></li>
              <li><Link to="/crm-solutions/" className="inline-block py-1.5 hover:text-[#FFD700]">CRM Solutions</Link></li>
              <li><Link to="/manpower-solutions/" className="inline-block py-1.5 hover:text-[#FFD700]">Manpower</Link></li>
              <li><Link to="/google-extractor/" className="inline-block py-1.5 hover:text-[#FFD700]">Extractor Tool</Link></li>
              <li><Link to="/ecommerce-services-usa/" className="inline-block py-1.5 hover:text-[#FFD700]">USA Marketplaces</Link></li>
              <li><Link to="/ecommerce-services-uae/" className="inline-block py-1.5 hover:text-[#FFD700]">UAE Marketplaces</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="display text-sm font-black uppercase tracking-widest text-[#FFD700]">Resources</h4>
            <ul className="mt-4 space-y-0 text-sm text-white/80">
              <li><Link to="/calculators/" className="inline-block py-1.5 hover:text-[#FFD700]">Marketplace Calculators</Link></li>
              <li><Link to="/blog/" className="inline-block py-1.5 hover:text-[#FFD700]">Blog</Link></li>
              <li><Link to="/testimonials/" className="inline-block py-1.5 hover:text-[#FFD700]">Testimonials</Link></li>
              <li><Link to="/faq/" className="inline-block py-1.5 hover:text-[#FFD700]">FAQ</Link></li>
              <li><Link to="/about/" className="inline-block py-1.5 hover:text-[#FFD700]">About Us</Link></li>
              <li><Link to="/policy/" className="inline-block py-1.5 hover:text-[#FFD700]">Privacy & Terms</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="display text-sm font-black uppercase tracking-widest text-[#FFD700]">Reach Us</h4>
            <ul className="mt-4 space-y-3 text-sm text-white/80">
              <li className="flex gap-2"><MapPin size={16} className="mt-0.5 shrink-0 text-[#FFD700]" /> {COMPANY.address}</li>
              <li className="flex items-center gap-2"><Phone size={16} className="text-[#FFD700]" /> <a href={`tel:${COMPANY.phoneTel}`} className="hover:text-[#FFD700]">Call {COMPANY.phone}</a></li>
              <li className="flex items-center gap-2"><MessageCircle size={16} className="text-[#FFD700]" /> <a href={`https://wa.me/${COMPANY.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="hover:text-[#FFD700]">WhatsApp {COMPANY.whatsappDisplay}</a></li>
              <li className="flex items-center gap-2"><Mail size={16} className="text-[#FFD700]" /> <a href={`mailto:${COMPANY.email}`} className="hover:text-[#FFD700]">{COMPANY.email}</a></li>
            </ul>
            <div className="mt-5">
              <GoogleReviewsCard variant="inline" />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/15 pt-6 md:flex-row md:items-center">
          <p className="text-xs text-white/60">© {new Date().getFullYear()} Orina Enterprise. All rights reserved.</p>
          <p className="text-xs text-white/60">
            Amazon SPN Verified · JioMart Verified Partner
          </p>
          <p className="text-xs text-white/60">
            <Link to="/policy/" className="hover:text-[#FFD700]">Privacy Policy</Link>
            <span className="mx-2">·</span>
            <Link to="/policy/" className="hover:text-[#FFD700]">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
